import React from 'react'
import { useNavigate, Link } from 'react-router-dom'
import './LandingPage.css'

const TermsOfServicePage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="landing-page">
      <nav className="landing-nav">
        <div className="nav-container">
          <div className="logo">
            <h2>Spread Agent</h2>
          </div>
          <div className="nav-links">
            <Link to="/" className="nav-link">ホーム</Link>
            <Link to="/login" className="nav-link">ログイン</Link>
            <Link to="/signup" className="cta-button">登録</Link>
          </div>
        </div>
      </nav>

      <div className="terms-container" style={{ maxWidth: '800px', margin: '80px auto 100px', padding: '0 20px', minHeight: 'calc(100vh - 400px)' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '2rem', textAlign: 'center' }}>利用規約</h1>
        
        <div style={{ lineHeight: '1.8', color: '#333' }}>
          <p style={{ marginBottom: '1.5rem' }}>最終更新日: 2025年1月18日</p>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第1条（適用）</h2>
            <p>本規約は、株式会社kintsuba（以下「当社」といいます。）が提供するAI営業支援サービス「spread.」（以下「本サービス」といいます。）の利用条件を定めるものです。ユーザーの皆様（以下「ユーザー」といいます。）には、本規約に従って本サービスをご利用いただきます。</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第2条（利用登録）</h2>
            <ol style={{ paddingLeft: '2rem' }}>
              <li>利用登録の申請は、本規約に同意の上、当社の定める方法によって行うものとします。</li>
              <li>当社は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあります。
                <ul style={{ marginTop: '0.5rem' }}>
                  <li>虚偽の事項を届け出た場合</li>
                  <li>本規約に違反したことがある者からの申請である場合</li>
                  <li>その他、当社が利用登録を相当でないと判断した場合</li>
                </ul>
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第3条（ユーザーIDおよびパスワードの管理）</h2>
            <ol style={{ paddingLeft: '2rem' }}>
              <li>ユーザーは、自己の責任において、本サービスのユーザーIDおよびパスワードを適切に管理するものとします。</li>
              <li>ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与し、もしくは第三者と共用することはできません。</li>
            </ol>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第4条（利用料金および支払方法）</h2>
            <ol style={{ paddingLeft: '2rem' }}>
              <li>ユーザーは、本サービスの利用に際し、当社が別途定める利用料金を支払うものとします。</li>
              <li>料金の支払い方法は、クレジットカード決済その他当社が指定する方法によるものとします。</li>
              <li>ユーザーが利用料金の支払を遅滞した場合、年14.6％の割合による遅延損害金を支払うものとします。</li>
            </ol>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第5条（AI生成コンテンツの利用）</h2>
            <ol style={{ paddingLeft: '2rem' }}>
              <li>本サービスは、AI技術を用いて営業メールやリード情報を生成します。</li>
              <li>ユーザーは、AI生成コンテンツを利用する際、以下の事項を理解し同意するものとします：
                <ul style={{ marginTop: '0.5rem' }}>
                  <li>生成されたコンテンツの正確性、適法性、第三者の権利侵害の有無について、ユーザー自身で確認する責任があること</li>
                  <li>生成されたコンテンツの使用により生じた結果について、当社は責任を負わないこと</li>
                  <li>営業活動に使用する前に、適用される法令（特定電子メール法等）を遵守すること</li>
                </ul>
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第6条（禁止事項）</h2>
            <p>ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
            <ol style={{ paddingLeft: '2rem', marginTop: '1rem' }}>
              <li>法令または公序良俗に違反する行為</li>
              <li>犯罪行為に関連する行為</li>
              <li>当社、本サービスの他のユーザー、またはその他第三者のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為</li>
              <li>当社のサービスの運営を妨害するおそれのある行為</li>
              <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
              <li>不正アクセスをし、またはこれを試みる行為</li>
              <li>スパムメールの送信等、不特定多数への無差別な営業活動</li>
              <li>AIを用いて生成したコンテンツを、人間が作成したものと偽って使用する行為</li>
              <li>当社が事前に許諾しない本サービス上での宣伝、広告、勧誘、または営業行為</li>
              <li>その他、当社が不適切と判断する行為</li>
            </ol>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第7条（本サービスの提供の停止等）</h2>
            <ol style={{ paddingLeft: '2rem' }}>
              <li>当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。
                <ul style={{ marginTop: '0.5rem' }}>
                  <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
                  <li>地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合</li>
                  <li>コンピュータまたは通信回線等が事故により停止した場合</li>
                  <li>その他、当社が本サービスの提供が困難と判断した場合</li>
                </ul>
              </li>
            </ol>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第8条（知的財産権）</h2>
            <ol style={{ paddingLeft: '2rem' }}>
              <li>本サービスおよび本サービスに関連する一切の情報についての著作権およびその他の知的財産権はすべて当社または当社にライセンスを許諾している者に帰属しており、ユーザーは無断で複製、譲渡、貸与、翻訳、改変、転載、公衆送信（送信可能化を含みます。）、伝送、配布、出版、営業使用等をしてはならないものとします。</li>
              <li>ユーザーが本サービスを利用して生成したコンテンツの著作権は、ユーザーに帰属します。ただし、当社は、サービス改善のため、匿名化された形でこれらのデータを分析・利用することができるものとします。</li>
            </ol>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第9条（個人情報の取扱い）</h2>
            <p>当社は、本サービスの利用によって取得する個人情報については、当社「プライバシーポリシー」に従い適切に取り扱うものとします。</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第10条（免責事項）</h2>
            <ol style={{ paddingLeft: '2rem' }}>
              <li>当社は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。</li>
              <li>当社は、本サービスによってユーザーに生じたあらゆる損害について、一切の責任を負いません。ただし、本サービスに関する当社とユーザーとの間の契約（本規約を含みます。）が消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。</li>
              <li>前項ただし書に定める場合であっても、当社は、当社の過失（重過失を除きます。）による債務不履行または不法行為によりユーザーに生じた損害のうち特別な事情から生じた損害（当社またはユーザーが損害発生につき予見し、または予見し得た場合を含みます。）について一切の責任を負いません。</li>
            </ol>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第11条（サービス内容の変更等）</h2>
            <p>当社は、ユーザーへの事前の通知なく、本サービスの内容を変更、追加または廃止することがあり、ユーザーはこれを承諾するものとします。</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第12条（利用規約の変更）</h2>
            <ol style={{ paddingLeft: '2rem' }}>
              <li>当社は以下の場合には、ユーザーの個別の同意を要せず、本規約を変更することができるものとします。
                <ul style={{ marginTop: '0.5rem' }}>
                  <li>本規約の変更がユーザーの一般の利益に適合するとき</li>
                  <li>本規約の変更が本サービス利用契約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき</li>
                </ul>
              </li>
              <li>当社はユーザーに対し、前項による本規約の変更にあたり、事前に、本規約を変更する旨および変更後の本規約の内容並びにその効力発生時期を通知します。</li>
            </ol>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第13条（通知または連絡）</h2>
            <p>ユーザーと当社との間の通知または連絡は、当社の定める方法によって行うものとします。当社は、ユーザーから、当社が別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、これらは、発信時にユーザーへ到達したものとみなします。</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第14条（権利義務の譲渡の禁止）</h2>
            <p>ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>第15条（準拠法・裁判管轄）</h2>
            <ol style={{ paddingLeft: '2rem' }}>
              <li>本規約の解釈にあたっては、日本法を準拠法とします。</li>
              <li>本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。</li>
            </ol>
          </section>

          <section style={{ marginBottom: '4rem' }}>
            <p style={{ marginTop: '3rem', textAlign: 'center' }}>以上</p>
          </section>
        </div>
      </div>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>Spread Agent</h4>
              <p>AIで営業を自動化</p>
            </div>
            <div className="footer-section">
              <h4>製品</h4>
              <ul>
                <li><Link to="/#features">機能</Link></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>サポート</h4>
              <ul>
                <li><Link to="/#contact">お問い合わせ</Link></li>
                <li><button type="button" className="footer-link" onClick={() => navigate('/company-profile')}>会社概要</button></li>
                <li><button type="button" className="footer-link" onClick={() => navigate('/terms-of-service')}>利用規約</button></li>
                <li><button type="button" className="footer-link" onClick={() => navigate('/privacy-policy')}>プライバシーポリシー</button></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Spread Agent. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default TermsOfServicePage
